import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit, half } = measures

export const signupContainer = css`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const signupSection = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: ${3 * unit}px;
  width: 100%;
`

export const tabList = css`
  border: none;
  text-align: center;
  list-style: none;
  margin-bottom: ${unit}px;
`

export const tab = css`
  display: inline-block;

  position: relative;

  margin: 0 ${half}px;

  padding: ${unit}px;
  min-width: ${10 * unit}px;

  border-bottom: 2px solid ${colors.grays.gray1};

  outline: none;

  cursor: pointer;
`

export const selectedTab = css`
  color: ${colors.oranges.orange1};
  border-color: ${colors.oranges.orange4};
`
